import './inter-ui/inter.css';
import WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: ['Noto Serif:100,200,300,400,500,600,700,800,900', 'sans-serif'],
  },
});
